/*
<summary>
   This functional layout component provides our application layout (after login) that contain left menubar,
   top nav bar and footer.
   Developer:Aashish Singh, Created Date:29-March-2023
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/
import React from 'react';
// import Footer from "../footer/footer";
import { useLocation } from 'react-router-dom';
import { useStore } from '../../contexts/store-provider';
import RoutePageHead from '../head/route-page-head';
import LeftNavBar from '../navbar/left-navbar';
import './layout.css';

const Layout: React.FC<any> = (props) => {
  const { authStore } = useStore();
  const location = useLocation();
  const hideNavbarRoutes = [
    '/AccountActivation',
    '/DIDInnovateHub/AccountActivation',
  ];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);
  return (
    <div
      className="header-fixed sidebar-fixed sidebar-dark header-light"
      id="body"
    >
      <RoutePageHead />
      <div className="wrapper">
        {shouldHideNavbar !== true && (
          <LeftNavBar
            email={authStore.getEmail}
            userType={authStore.getUserType}
          />
        )}

        <main className="main-wrapper">
          {/* <TopNavBar componentName={location?.pathname.replace(/^\//, '')}/> */}
          <div
            id="moveContent"
            className="content-wrapper container-fluid"
          >
            {props.children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
